import * as React from 'react';
import { Stack, Skeleton } from '@chakra-ui/react';

export interface IProps {
  skeletonCount?: number;
  skeletonHeight?: number;
  skeletonSpacing?: number;
}

const SkeletonLoader: React.FC<IProps> = ({ skeletonCount = 3, skeletonHeight = 4, skeletonSpacing = 6 }: IProps) => {
  const skeletonArray = new Array(skeletonCount).fill('');
  return (
    <Stack spacing={skeletonSpacing}>
      {skeletonArray.map((_, i) => (
        <Skeleton key={i} height={skeletonHeight} />
      ))}
    </Stack>
  );
};

export default SkeletonLoader;
